export class MapFeatures {
	constructor(map) {
		this.map = map;
	}

	addMarkerToMap(coordinates, options = {icon, draggable, title: "", info: null, infoWindow: {content: ""}}) {
		let _opts = {
			drag: options.draggable,
			icon: options.icon,
			title: options.title,
			info: options.info,
			onDragend: options.onDragend,
			infoWindow: {
				content: options.infoWindow.content,
			},
			onClick: (e, coords) => {
				setTimeout(() => {
					Anuket.streetView(
						{lat: parseFloat(coords.lat), lng: parseFloat(coords.lng)},
						{container: `#streerview-vp-${this.visitPoint.id}`}
					);
				}, 100);
			},
		};
		let marker = new google.maps.Marker({
			position: {lat: coordinates.cy, lng: coordinates.cx},
			map: this.map,
			title: _opts.title,
			icon: _opts.icon,
			info: _opts.info,
			draggable: _opts.drag,
			click: function (e) {
				if (typeof _opts.onClick === "function") {
					_opts.onClick(e, {lat: coordinates.cy, lng: coordinates.cx});
				}
			},
		});
		if (options.infoWindow.content !== "") {
			const infowindow = new google.maps.InfoWindow({
				content: _opts.infoWindow.content,
			});
			marker.addListener("click", () => {
				infowindow.close();
				infowindow.open({
					anchor: marker,
					map: this.map,
				});
			});
			google.maps.event.addListener(this.map, "click", function () {
				infowindow.close();
			});
			marker.infoWindow = infowindow;
		}
		if (_opts.drag === true) {
			google.maps.event.addListener(marker, "dragend", () => {
				let pos = {};
				let getPosition = marker.getPosition();
				pos.lat = getPosition.lat();
				pos.lng = getPosition.lng();
				_opts.onDragend({lat: pos.lat, lng: pos.lng});
			});
		}
		this.map.setCenter({lat: parseFloat(coordinates.cy), lng: parseFloat(coordinates.cx)});
		this.map.setZoom(14);
		return marker;
	}

	removeMarker(marker) {
		marker.setMap(null);
	}

	_getMarkerBounds(marker) {
		let boundsMarker = new google.maps.LatLngBounds();
		boundsMarker.extend(marker.getPosition());
		return boundsMarker;
	}
	_getPolygonBounds(polygon) {
		let boundsPolygon = new google.maps.LatLngBounds();
		let polyPaths = polygon.getPaths();
		for (let i = 0; i < polyPaths.getLength(); i++) {
			let path = polyPaths.getAt(i);
			for (let ii = 0; ii < path.getLength(); ii++) {
				boundsPolygon.extend(path.getAt(ii));
			}
		}
		return boundsPolygon;
	}
	_getPolylineBounds(polyline) {
		let bounds = new google.maps.LatLngBounds();
		let linePaths = polyline.getPath().getArray();
		for (const linePath of linePaths) {
			bounds.extend(linePath);
		}
		return bounds;
	}

	fitBounds(shape, type) {
		console.warn("fitBounds fn:", type);
		if (!this.map) {
			return false;
		}
		if (!shape) {
			console.warn("fitBounds: Shape must be a Marker, a Circle, a Polygon or a Polyline Object.");
			return false;
		}
		if (!type) {
			console.warn("fitBounds: type missing option [marker, circle, polygon, polyline].");
			return false;
		}
		let bounds;
		switch (type) {
			case "marker":
				if (!shape.getVisible()) {
					console.warn("fitBounds: shape is not visible");
					return;
				}
				bounds = this._getMarkerBounds(shape);
				break;
			case "circle":
				bounds = shape.getBounds();
				break;
			case "polygon":
				bounds = this._getPolygonBounds(shape);
				break;
			case "polyline":
				bounds = this._getPolylineBounds(shape);
				break;
			default:
				console.warn("fitBounds: unknown option", type);
				return;
		}
		if (bounds) {
			this.map.fitBounds(bounds);
		}
	}

	fitBoundsMarkerGroup(markerArray = []) {
		const markerGroupBounds = new google.maps.LatLngBounds();
		for (let marker of markerArray) {
			const latlng = new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng());
			markerGroupBounds.extend(latlng);
		}
		this.map.fitBounds(markerGroupBounds, 80);
	}

	fitboundGeoJson(geoJson) {
		let lat = {},
			lng = {};
		geoJson.features.forEach(function (feature) {
			lng["max"] =
				!lng["max"] || Math.abs(lng["max"]) > Math.abs(feature.geometry.coordinates[0])
					? feature.geometry.coordinates[0]
					: lng["max"];
			lng["min"] =
				!lng["min"] || Math.abs(lng["min"]) < Math.abs(feature.geometry.coordinates[0])
					? feature.geometry.coordinates[0]
					: lng["min"];
			lat["max"] =
				!lat["max"] || Math.abs(lat["max"]) > Math.abs(feature.geometry.coordinates[1])
					? feature.geometry.coordinates[1]
					: lat["max"];
			lat["min"] =
				!lat["min"] || Math.abs(lat["min"]) < Math.abs(feature.geometry.coordinates[1])
					? feature.geometry.coordinates[1]
					: lat["min"];
		});
		let bounds = new google.maps.LatLngBounds();
		bounds.extend(new google.maps.LatLng(lat.min - 0.01, lng.min - 0.01));
		bounds.extend(new google.maps.LatLng(lat.max - 0.01, lng.max - 0.01));
		this.map.fitBounds(bounds, 80);
		this.map.setCenter(bounds.getCenter());
	}
}
